define('model/base.workflow.model',['require','exports','module','underscore','datakit/datakit','evicommon/pagination.util','evicommon/spf/model/sort','evicommon/spf/model/paginate','evicommon/state/param.adapter'],function(require, exports, module) {
  //prettier-ignore
  var _              = require('underscore'),
      DataKit        = require('datakit/datakit'),
      PaginationUtil = require('evicommon/pagination.util'),
      SortModel      = require('evicommon/spf/model/sort'),
      PaginateModel  = require('evicommon/spf/model/paginate'),
      ParamAdadpter  = require('evicommon/state/param.adapter');

  var WorkflowSortAdapter = ParamAdadpter.extend({
    sortDirections: {
      ascending: 'asc',
      descending: 'desc',
    },

    serializeModel: function() {
      var data = {};
      var sortField = this.model.get(SortModel.SORT_FIELD);
      var sortDirection = this.getSortDirection();

      if (sortField) {
        data.sort = sortField;
      }
      if (sortDirection) {
        data.order = sortDirection;
      }
      return data;
    },

    getSortDirection: function() {
      var direction = this.model.get(SortModel.SORT_DIRECTION);
      return this.sortDirections[direction];
    },
  });

  var WorkflowPaginateAdapter = ParamAdadpter.extend({
    serializeModel: function() {
      var data = {};
      var pageNumber = Math.max(0, this.model.get(PaginateModel.PAGE) - 1);
      var pageSize = this.model.get(PaginateModel.SIZE);

      if (pageNumber && pageSize) {
        data.start = pageNumber * pageSize;
      } else {
        data.start = 0;
      }

      if (pageSize) {
        data.size = pageSize;
      } else {
        data.size = 10;
      }

      return data;
    },

    postprocess: function(data, resp) {
      var page = {};
      var startIndex = Number(resp.start) || 0;
      var totalItems = (page[PaginateModel.TOTAL_ITEMS] = Number(resp.total) || 0);
      var pageSize = Math.max(Number(resp.size) || 0, this.model.get(PaginateModel.SIZE));

      page[PaginateModel.PAGE] = Math.floor(startIndex / pageSize) + 1;
      page[PaginateModel.TOTAL_PAGES] = Math.ceil(totalItems / pageSize);

      this.model.set(page, { ignoreAutoFetch: true });
    },
  });

  // Check docs in docs/workflow.task.model.md

  var BaseWorkflowModel = DataKit.Model.extend(
    {},
    {
      Collection: DataKit.Collection.extend({
        // auto-fetch the collection
        // if the pagination model changes
        paginateAutoFetch: true,
        // auto-fetch the collection
        // when the sort model changes
        sortAutoFetch: true,

        constructor: function(models, options) {
          DataKit.Collection.apply(this, arguments);

          this.options = options || {};

          var sort = this.getOption('sort');
          var paginate = Mn._getValue(this.getOption('paginate') || this.getOption('page'));

          this.sort = PaginationUtil.createSort();
          this.paginate = PaginationUtil.createPaginate();

          if (sort && sort.field) {
            this.sort.set(SortModel.SORT_FIELD, sort.field);
            this.sort.set(SortModel.SORT_DIRECTION, sort.direction || SortModel.ASCENDING);
          }
          if (paginate && paginate.number) {
            this.paginate.set(PaginateModel.PAGE, paginate.number);
          }
          if (paginate && paginate.size) {
            this.paginate.set(PaginateModel.SIZE, paginate.size);
          }

          this.addAdapter(
            new WorkflowSortAdapter(this.sort, {
              autoFetch: this.getOption('sortAutoFetch'),
            })
          ).addAdapter(
            new WorkflowPaginateAdapter(this.paginate, {
              autoFetch: this.getOption('paginateAutoFetch'),
            })
          );
        },

        getOption: Mn.proxyGetOption,

        parse: function(response) {
          return _.result(response, 'data');
        },
      }),
    }
  );

  module.exports = BaseWorkflowModel;
});

